module.exports = __webpack_public_path__ + "static/img/temp-card.337ee0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/temp-card.png
// module id = 79
// module chunks = 0